import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class SaleService {
  seeContractDetails(productCategoryName, productPrice, storeId) {
    return securedAxiosInstance.get(`/store/${storeId}/plan_sales/simulation`, {
      params: toSnakeCase({ productPrice, productCategory: productCategoryName }),
    });
  }
}

export default new SaleService();
